// extracted by mini-css-extract-plugin
export default {"inner":"Tireurs_inner__8mr9Q","head":"Tireurs_head__vc2Kn","wrapper":"Tireurs_wrapper__C2bWS","button":"Tireurs_button__HMOKs"};